import { coreSlice } from './coreSlice/coreSlice';

const exports = {
    ...coreSlice,
};

export { exports as core };